const VALID_VALUES = ['HOME', 'MOBILE', 'WORK'];

const validatePhoneType = value => {
  const result = {
    patternMismatch: Boolean(value.length) && !VALID_VALUES.includes(value),
    valueMissing: !value.length,
  };

  result.errors = Object.keys(result).filter(key => result[key]);
  result.isValid = !result.errors.length;

  return result;
};

export { validatePhoneType };
